import { render, staticRenderFns } from "./ActivationDeliveredContentProvider.vue?vue&type=template&id=522926fb&"
import script from "./ActivationDeliveredContentProvider.vue?vue&type=script&lang=js&"
export * from "./ActivationDeliveredContentProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports